export default __webpack_public_path__ + "static/media/instagram.4923c2df.svg";